<!--  -->
<template>
    <div class="box" style="display: flex;flex-direction: row;">
      <div class="content" style="width: 25%;padding: 0;">
        <div style="width: 100%;background-color: #0053B9;padding: 20px 10px 20px;">
          <div style="display: flex;justify-content: flex-start;width: 100%;flex-direction: column;">
            <img src="../../assets/img/chuju/cj_sub_title.png" style="width: 30px;height: 20px;margin-left: 35px;" alt="">
            <span style="margin-left: 35px;margin-top: 10px;font-size: 26px;color: white;font-weight: 600;">{{ titleName }}</span>
          </div>
          <div style="margin-bottom: 10px;background-color: white;margin-left: 6%;width: 98%;margin-top: 20px;">
              <div style="display: flex;align-items: center;justify-content: flex-start;padding-left: 60px;height: 70px;" v-for="(item,index) in source" :style="indexSelected == index?'background-color:white':'background-color:#E5E5E5'"
              @click="tab(item,index)">
                <img src="../../assets/img/chuju/cj_sub_item.png" style="width: 20px;height: 20px;" alt="">
                <span style="margin-left: 15px;color: #2362AF;font-size: 18px;">{{ item.title }}</span>
              </div>
          </div>
        </div>
      </div>
      <div class="content" style="flex: 1;">
        <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 0 10px;width: 100%;border-bottom: 2px solid #DCDCDC;padding-bottom: 1px;">
            <div style="border-bottom: 3px solid #0053B9;height: 100%;display: flex;justify-content: flex-start;align-items: center;">
              <img src="../../assets/img/chuju/cj_sub_name.png" style="width: 20px;height: 20px;" alt="">
              <span style="font-size: 24px;color: #0053B9;margin-left: 5px;padding-right: 40px;">{{ titleNow }}</span>
            </div>
            <div>
              <el-breadcrumb separator="/">
                <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/NQI' }">NQI站点</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/NQIDetail' }">企业列表详情</el-breadcrumb-item> -->
                <el-breadcrumb-item :to="{ path: '/kitchenwareMain', query: {tab: 9} }">厨具首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{ titleName }}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
        </div>
        <div v-if="info.length > 0" style="width: 100%;">
          <div style="padding: 20px 10px;display: flex;flex-direction: column;border-bottom: 2px solid #DCDCDC;width: 100%;" v-for="item in info" @click="toDetail(item)">
              <span style="font-size: 18px;font-weight: 600;">{{ item.title }}</span>
              <span class="two-line-ellipsis" style="font-size: 13px;margin-top: 10px;">{{ getContent(item.content) }}</span>
          </div>
          <div class="bottom" style="display: flex;justify-content: center;align-items: center;margin: 20px 0 10px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNo"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
        </div>
        </div>
        <div v-else style="flex: 1;display: flex;align-items: center;justify-content: center;height: 235px;">
            <el-empty description="暂无数据"></el-empty>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Server,httpurl } from "@/server";
  export default {
    data () {
      return {
          id: '', // 文章id
          info: [],
          downloadUrl: '',
          files:[],

          indexSelected:0,
          itemNow:'',
          source:[],
          titleName:'',
          titleNow:'',
          isShow:false,
          showName:'',

          listHeight:300,


          pageNo:1,
          pageSize:10,
          total:0
      }
    },
    watch: {
        $route(newVal, oldVal) {
            this.titleName = this.$route.query.typename
            this.indexSelected = 0
            this.getLeftData(this.titleName)
        },
    },
    created() {
      this.downloadUrl = this.$downloadUrl
      this.titleName = this.$route.query.typename
      this.isShow = (this.$route.query.isMMain=='true')?true:false
      this.getLeftData(this.titleName)
    },
    methods: {
        handleSizeChange(val) {
          this.pageSize = val
          this.getData(this.itemNow.id)
          console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
          this.pageNo = val
          this.getData(this.itemNow.id)
          console.log(`当前页: ${val}`);
        },
        backFun () {
            history.go(-1);
        },
        getLeftData (name) {
            Server.getSubLeftData({
              title:name
            }).then(res => {
              console.log(res);
              this.source = res.result
              this.listHeight = this.source.length?(110 * this.source.length):300
              if (this.$route.query.showName) {
                  let isHas = false
                  this.source.forEach((item,index) => {
                      if (item.title == this.$route.query.showName) {
                          isHas = true
                          this.indexSelected = index
                          this.titleNow = item.title
                          this.itemNow = item
                          this.getData(item.id)
                      }
                  })
                  if (!isHas) {
                    this.titleNow = this.source[0].title
                    this.itemNow = this.source[0]
                    this.getData(this.source[0].id)
                  }
              } else {
                this.titleNow = this.source[0].title
                this.itemNow = this.source[0]
                this.getData(this.source[0].id)
              }
            })
        },
        getData(type) {
            Server.getSubLeftDataInfo({type: type,pageNo:this.pageNo,pageSize:this.pageSize}).then(res => {
                console.log(res);
                if(res.success) {
                  this.info = res.result.records
                  this.total = res.result.total
                }
            })
        },
        toDetail(item) {
          this.$router.push({
              path: '/cjContentDetail',
              query:{
                id:item.id,
                isMain:false,
                isShow:this.isShow,
                typename:this.titleName,
                showName:this.titleNow
              }
          })
        },
        getContent(richText) {
          if (!richText) {
              return '';
          }
          let parser = new DOMParser();
          let doc = parser.parseFromString(richText, 'text/html');
          return doc.body.textContent;
        },
        tab(item,index) {
          this.titleNow = item.title
          this.indexSelected = index;
          this.itemNow = item
          this.getData(item.id)
        },
      getUrl() {
        return httpurl + '/sys/common/static/';
      },
      fixImage (file) {
        var arr = file.split("/"); // 使用逗号分割字符串
        var lastElement = arr.slice(-1)[0]; // 取得最后一个元素
        return lastElement
      },
  
      async downloadExcel (fileName) {
          var fileUrl = this.getUrl()
        var fileLastName = this.fixImage(fileName).split("_")[0] + this.fixImage(fileName).slice(this.fixImage(fileName).lastIndexOf('.'))
        const x = new window.XMLHttpRequest();
        x.open('GET', this.getUrl() + fileName, true);
        x.responseType = 'blob';
        x.onload = () => {
            const url = window.URL.createObjectURL(x.response);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileLastName;
            a.click();
        };
        x.send();
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
      .content {
          margin: 20px 0 50px;
          background-color: #fff;
          padding: 50px ;
          box-sizing: border-box;
  
          display: flex;
          flex-direction: column;
          align-items: center;
          .title {
              font-size: 30px;
              font-weight: bold;
              margin-bottom: 45px;
              
          }
            .label {
                font-size: 16px;
                margin-top: 20px;
            }
          .img {
              margin: 50px 0;
              max-width: 100%;
          }
          .duration {
              line-height: 35px;
              text-indent: 0.5em;
          }
      }
      
      .two-line-ellipsis {
        width: 100%; /* 限制容器宽度 */
        display: -webkit-box; /* 弹性盒子模型（WebKit内核） */
        -webkit-box-orient: vertical; /* 垂直排列子元素 */
        -webkit-line-clamp: 2; /* 限制显示两行 */
        overflow: hidden; /* 隐藏超出部分 */
        text-overflow: ellipsis; /* 使用省略号 */
      }
  </style>
  